<template>
  <NuxtLink
    :href="
      localePath({
        path: '/our-stones',
      })
    "
    target="_blank"
    class="mt-2.5 inline-flex items-center gap-1 ui-text-m capitalize text-wood-900"
    :aria-label="$t('ariaLabelLearnMoreAbout', { title })"
  >
    <span class="underline">{{ $t("learnMore") }}</span>
    <UiIcon name="chevron_next" class="size-2.5" />
  </NuxtLink>
</template>

<script lang="ts" setup>
defineProps<{ title: string }>();
const localePath = useLocalePathPolyfill();

</script>
